/* Complete the look (ring pages) + Finish the set (cart drawer): add a necklace/earring to the cart without leaving the
   page, and open the quick-view modal. Built 2026-10-13. Event delegation on document so the cart drawer's re-rendered
   markup keeps working. The add path copies the sizer's proven recipe in mens-ring.js: cart/add.js with the theme's
   bundled sections, then cart.js, then the theme's cart:change event (the drawer refreshes and opens). Falls back to the
   GET permalink if anything fails. Loaded by the two ring sections and by cart-drawer.liquid; guarded against double init. */
(function () {
  if (window.__feCompleteLook) return;
  window.__feCompleteLook = true;

  function addVariant(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    var vid = btn.getAttribute('data-fcl-add');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var fallback = function () { window.location.href = root + 'cart/add?id=' + vid + '&quantity=1'; };
    if (!window.fetch || !window.FormData) { fallback(); return; }
    btn.setAttribute('aria-busy', 'true');
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    var fd = new FormData();
    fd.set('id', vid);
    fd.set('quantity', '1');
    fd.set('sections', sections.join(','));
    fd.set('sections_url', root + 'variants/' + vid);
    fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'add failed'); return j; }); })
      .then(function (added) {
        var st = (window.themeVariables && window.themeVariables.settings) || {};
        if (st.cartType === 'page' || st.pageType === 'cart') { window.location.href = root + 'cart'; return; }
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          cart.sections = added.sections || {};
          closeModals();
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
        });
      })
      .catch(fallback)
      .then(function () { btn.removeAttribute('aria-busy'); });
  }

  var openModal = null, lastFocus = null;
  function closeModals() {
    if (!openModal) return;
    openModal.hidden = true;
    document.body.style.overflow = '';
    openModal = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function open(id, trigger) {
    var m = document.getElementById(id);
    if (!m) return;
    closeModals();
    lastFocus = trigger;
    m.hidden = false;
    document.body.style.overflow = 'hidden';
    openModal = m;
    var c = m.querySelector('[data-fcl-close]');
    if (c) c.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentElement;
    if (!t) return;
    var add = t.closest('[data-fcl-add]');
    if (add) { e.preventDefault(); addVariant(add); return; }
    var op = t.closest('[data-fcl-open]');
    if (op) { e.preventDefault(); open(op.getAttribute('data-fcl-open'), op); return; }
    var th = t.closest('.fcl-thumb');
    if (th && openModal && openModal.contains(th)) {
      var main = openModal.querySelector('.fcl-main');
      if (main) main.src = th.getAttribute('data-fcl-src');
      openModal.querySelectorAll('.fcl-thumb').forEach(function (x) { x.classList.toggle('is-active', x === th); });
      return;
    }
    if (t.closest('[data-fcl-close]')) { e.preventDefault(); closeModals(); return; }
    if (openModal && t === openModal) { closeModals(); }
  });
  document.addEventListener('keydown', function (e) {
    if (!openModal) return;
    if (e.key === 'Escape') { closeModals(); return; }
    if (e.key === 'Tab') {
      var f = openModal.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();
